// TODO: Move items from management.js to this file.
import { company_name } from "@/i18n/variables";

const page = {
	password_tile: {
		credentials_saved_button: "Ik heb de gegevens opgeslagen",
		description:
			"De inloggegevens voor uw VPS staan <strong>30 dagen</strong> in de wachtwoordkluis. Sla deze gegevens op in uw eigen wachtwoordmanager.",
		description_completed: `De inloggegevens uit de wachtwoordkluis hebt u opgeslagen in uw wachtwoordmanager. Als u uw wachtwoord niet heeft opgeslagen, kunt u contact op nemen met ${company_name}.`,
		password_vault_button: "Naar wachtwoordkluis",
		title: "Inloggegevens",
	},
};

const manage = {
	page: page,
};

export default manage;
